var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimacIconoUbicacionMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ae186b;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,0h24v24H0V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.5,3l-.16.03-5.34,2.07-6-2.1-5.64,1.9c-.21.07-.36.25-.36.48v15.12c0,.28.22.5.5.5l.16-.03,5.34-2.07,6,2.1,5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5Zm-10.5,2.47l4,1.4v11.66l-4-1.4V5.47Zm-5,.99l3-1.01v11.7l-3,1.16V6.46Zm14,11.08l-3,1.01V6.86l3-1.16v11.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimacIconoUbicacionMapa);
export default __webpack_public_path__ + "static/media/SIMAC_Icono_ubicacion_mapa.45d8a8f64c5e0a3dae15add35488da92.svg";
export { ForwardRef as ReactComponent };